import { gsap } from '../global/gsap';

const initSubmitMemory = (section) => {
    // Form fields
    const hasReference = section.classList.contains('js-submit-memory--post') ? true : false;
    const referencePostId = hasReference ? section.dataset.id : null;
    const referencePostType = hasReference ? section.dataset.type : null;
    const form = section.querySelector('.js-memory-form');
    const idField = form.querySelector('.js-post-id');
    const titleInput = section.querySelector('.js-title-input');
    const titleField = form.querySelector('.js-title');
    const imageInput = section.querySelector('.js-media-input');
    const imagePreview = section.querySelector('.js-preview');
    const imageField = form.querySelector('.js-image');
    const youtubeInput = section.querySelector('.js-youtube-input');
    const youtubeField = form.querySelector('.js-youtube-link');
    const descriptionInput = section.querySelector('.js-description-input');
    const descriptionField = form.querySelector('.js-description');
    const tagsField = form.querySelector('.js-tags');
    const firstNameInput = section.querySelector('.js-first-name-input');
    const firstName = form.querySelector('.js-first-name');
    const surnameInput = section.querySelector('.js-surname-input');
    const surname = form.querySelector('.js-surname');
    const emailInput = section.querySelector('.js-email-input');
    const email = form.querySelector('.js-email');
    const countryInput = section.querySelector('.js-country-input');
    const country = form.querySelector('.js-country');
    const captchaField = section.querySelector('.js-recaptcha-token');
    const newsletterInput = section.querySelector('.js-newsletter-input');
    const submitButton = section.querySelector('.js-submit-memory');

    // Other bits
    const stages = section.querySelectorAll('.js-stage');
    const showSearch = section.querySelector('.js-show-search');
    const showStage = section.querySelector('.js-show-stage');
    const releaseSearch = section.querySelector('.js-release-search');
    const releaseStage = section.querySelector('.js-release-stage');
    const choiceButtons = section.querySelectorAll('.js-choice');
    const cardContainers = section.querySelectorAll('.js-post-selection');
    const formTypeLabel = section.querySelector('.js-form-type-label');
    const memoryTextLabel = section.querySelector('.js-memory-text-label');
    const memoryDateLabel = section.querySelector('.js-memory-date-label');
    const wordCountEl = section.querySelector('.js-word-count');
    const tags = section.querySelectorAll('.js-tag');
    const tagContainer = section.querySelector('.js-tag-container');
    const prevButton = section.querySelector('.js-prev-button');
    const nextButton = section.querySelector('.js-next-button');
    const nextButtonLabel = nextButton.querySelector('.js-button-label');
    const clearSelection = section.querySelector('.js-clear-selection');
    const pageDots = section.querySelectorAll('.js-page-dot')
    let activeTags = [];
    let validYoutubeUrl = false;

    // Keep track of progress
    let activeStage = 0;
    let formType = null;
    let submitting = false;

    // youtube URL checker
    const youtubeUrlChecker = async (value) => {
        try {
            const url = new URL(value); 
            return (
                (url.hostname === 'www.youtube.com' ||
                    url.hostname === 'youtube.com' ||
                    url.hostname === 'youtu.be') &&
                (url.searchParams.has('v') || url.hostname === 'youtu.be')
            );
        } catch {
            return false;
        }
    };

    // Toggle section helper function
    const toggleSection = (indexToShow) => {
    if (indexToShow > activeStage) {
        const nextStage = section.querySelector(`.js-stage[data-index="${indexToShow}"]`);
        if (nextStage) {
            nextStage.classList.add('is-active');
            const inputToFocus = nextStage.querySelector('input');
            if (inputToFocus) inputToFocus.focus();
        }
        activeStage++;
    } else {
        // Going backward — remove the highest active .js-stage
        const activeStages = [...section.querySelectorAll('.js-stage.is-active')];
        const stageToHide = activeStages[activeStages.length - 1];
        if (stageToHide) stageToHide.classList.remove('is-active');
        activeStage--;
    }

    toggleArrow();
    togglePageDots(activeStage + 1);
    scrollToTop();
};

    const togglePageDots = (current) => {
        pageDots.forEach((dot) => {
            dot.classList.remove('is-active');
        });

        if(pageDots[current]) {
            pageDots[current].classList.add('is-active');
        } else {
            pageDots[0].classList.add('is-active');
        }
    }

    const scrollToTop = () => {
        gsap.to(window, { duration: 0.2, scrollTo: section });
    };

    const toggleArrow = () => {
        nextButton.classList.remove('is-active');
        nextButtonLabel.innerText = 'Next Step';

        if (
            activeStage === 1 &&
            titleInput.value !== '' &&
            descriptionInput.value !== ''
        ) {
            nextButton.classList.add('is-active');
        }

        if (activeStage === 2) {
            if (!validYoutubeUrl && !imageInput.files[0]) {
                nextButtonLabel.innerText = 'Skip step';
            }
            nextButton.classList.add('is-active');
        }

        if (activeStage === 3) {
            nextButton.classList.remove('is-active');
        }
    };

    nextButton.addEventListener('click', () => {
        toggleSection(activeStage + 1);
    });

    prevButton.addEventListener('click', () => {
        if (activeStage === 0) {
            showStage.classList.remove('is-active');
            releaseStage.classList.remove('is-active');
            formType = null;
            toggleArrow();
            togglePageDots(0);
            scrollToTop();
        } else {
            toggleSection(activeStage - 1);
        }
    });

    clearSelection.addEventListener('click', () => {
        toggleSection(activeStage - 1);
    });

    // Form type selector
    choiceButtons.forEach((button) => {
        const { type } = button.dataset;
        button.addEventListener('click', () => {
            formType = type;
            if (type === 'show') {
                showStage.classList.add('is-active');
                releaseStage.classList.remove('is-active');
                showSearch.focus();
                activeSection = 0;
            } else if (type === 'release') {
                releaseStage.classList.add('is-active');
                showStage.classList.remove('is-active');
                releaseSearch.focus();
                activeSection = 0;
            }

            togglePageDots(1);
            scrollToTop();
        });
    });

    // Post selection
    cardContainers.forEach((container) => {
        container.addEventListener('click', (e) => {
            const { target } = e;

            if (target.classList.contains('js-card')) {
                const { id, name, date } = target.dataset;
                idField.value = id;
                memoryTextLabel.innerHTML = name;
                memoryDateLabel.innerHTML = date ?? null;
                formTypeLabel.innerText = formType;
                toggleSection(1);
            }
        });
    });

    // Title
    titleInput.addEventListener('input', (e) => {
        const { value } = e.target;
        titleField.value = value;
        toggleArrow();
    });

    // Description
    descriptionInput.addEventListener('input', (e) => {
        const { value } = e.target;
        const charCount = value.length;

        if (charCount > 300) {
            e.target.value = value.slice(0, 300);
            descriptionField.value = e.target.value;
        } else {
            descriptionField.value = value;
        }

        if (wordCountEl) {
            wordCountEl.textContent = `(${Math.min(charCount, 300)}/${300})`;
        }

        toggleArrow();
    });

    // Media upload
    imageInput.addEventListener('change', () => {
        const file = imageInput.files[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = ['image/jpeg'];
        if (!allowedTypes.includes(file.type)) {
            alert('Only JPG files are allowed.');
            imageInput.value = '';
            return;
        }

        // Validate file size (3MB)
        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize) {
            alert('File must be less than 3MB.');
            imageInput.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            imagePreview.classList.remove('is-hidden');
            imagePreview.src = e.target.result;
            imagePreview.style.display = 'block';
        };

        reader.readAsDataURL(file);

        // Transfer the file to the hidden input that gets submitted
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        imageField.files = dataTransfer.files;

        toggleArrow();
    });

    // Youtube
    youtubeInput.addEventListener('input', async (e) => {
        const { value } = e.target;
        validYoutubeUrl = await youtubeUrlChecker(value);
        youtubeInput.parentNode.classList.toggle(
            'input-error',
            value.length > 0 && !validYoutubeUrl,
        );
        youtubeUrlChecker(value);
        if (validYoutubeUrl) {
            youtubeField.value = value;
        }
        toggleArrow();
    });

    // Tags
    tags.forEach((tag) => {
        const { id } = tag.dataset;

        tag.addEventListener('click', () => {
            if (activeTags.includes(id)) {
                tag.classList.remove('is-active');
                activeTags = activeTags.filter((activeTag) => activeTag !== id);
            } else if (activeTags.length < 3) {
                tag.classList.add('is-active');
                activeTags.push(id);
            }

            tag.parentNode.classList.toggle('is-full', activeTags.length >= 3);

            tagsField.value = activeTags.join(', ');
        });
    });

    // First name
    firstNameInput.addEventListener('change', (e) => {
        const { value } = e.target;
        firstName.value = value;
    });

    // Surname
    surnameInput.addEventListener('change', (e) => {
        const { value } = e.target;
        surname.value = value;
    });

    // Email
    emailInput.addEventListener('change', (e) => {
        const { value } = e.target;
        email.value = value;
    });

    // Country
    countryInput.addEventListener('change', (e) => {
        const { value } = e.target;
        country.value = value;
    });

    // Form submit
    submitButton.addEventListener('click', (e) => {
        if(!submitButton.classList.contains('inactive') || submitting) {
            e.preventDefault();
            const newsletterStatus = newsletterInput.checked;
            submitting = true;
            submitButton.classList.add('inactive');
            submitButton.classList.add('working');
            submitButton.innerText = 'Submitting memory';
            
            if(newsletterStatus) {
                window.open('https://dispatch.os.fan/dispatch-newsletter-sign-up', '_blank')
            }

            grecaptcha.ready(() => {
                grecaptcha
                    .execute('6LeJ6PEsAAAAAKrMaQ8DNJDN0U5UQFbW7QTeBDJL', {
                        action: 'submit_custom_form',
                    })
                    .then((token) => {
                        captchaField.value = token;
                        form.submit();
                    });
            });
        }
    });



    // Logic for skipping steps if there's a referenced post

    const formatDate = (dateStr) => {
        if (!dateStr) return null;
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        const date = new Date(`${year}-${month}-${day}T00:00:00`);
        if (isNaN(date.getTime())) return null;
        return date.toLocaleDateString('en-GB', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }

    if(referencePostId) {
        
        gsap.to(window, { duration: 0, scrollTo: section });
        let data = null;
        formType = referencePostType;

        if(referencePostType === 'release') {
            data = releaseData.releases;
        } else if (referencePostType === 'show') {
             data = showData.shows;
        }

        const matchingItem = data.find(show => show.id === parseInt(referencePostId, 10));

        if(!matchingItem) {
            return;
        }

        idField.value = matchingItem.id;
        memoryTextLabel.innerHTML = matchingItem.title;
        memoryDateLabel.innerHTML = formatDate(matchingItem.date) ?? null;
        formTypeLabel.innerText = formType;

        stages.forEach((stage) => {
            stage.classList.add('no-transition');
        })

        toggleSection(1, true);

        stages.forEach((stage) => {
            stage.classList.remove('no-transition');
        })
    
    }
};

export default initSubmitMemory;
